import { useEffect, useState } from "react";

import { FormControl, InputLabel, OutlinedInput, Select } from "@mui/material";
import { useLazyGetProductsQuery } from "@modules/product";
import { ApiEndpoint } from "@constants/index";
import { useFormContext } from "react-hook-form";

import { StyledMenuItem } from "./styled";
import { ICreateRecipeFormData } from "@pages/RecipeMutation/helper/types";

const ProductsList = () => {
  const [getProducts] = useLazyGetProductsQuery()
  const [options, setOptions] = useState<{value: string; label: string; image: string}[]>([]);
  const { watch, setValue } = useFormContext<ICreateRecipeFormData>()

  const productsList = watch('productsList')

  const handleChange = (event: any) => {
    const { target: { value } } = event;

    setValue('productsList', value)
  };

  useEffect(() => {
    const handleRequest = async () => {
      const { products } = await getProducts({ limit: 500, offset: 0 }).unwrap()

      const result = products.map(({ id, titleEn, images }) => {
        const img = images.find((image) => image.isMain)

        return {
          value: id,
          label: titleEn,
          image: img?.url || images[0]?.url
        }
      })

      setOptions(result)
    }

    handleRequest()
  }, [])

  return (
    <div>
      <FormControl sx={{ margin: '7px 0 7px 0', width: 300 }}>
        <InputLabel id="demo-multiple-name-label">Products</InputLabel>
        <Select
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          sx={{
            '#demo-multiple-name': {
              display: 'grid',
              gap: '3px',
              gridTemplateColumns: '10fr 10fr 1fr'
            }
          }}
          multiple
          value={productsList || []}
          onChange={handleChange}
          input={<OutlinedInput label="Products" />}
        >
          {options.map((option) => (
            <StyledMenuItem
              key={option.value}
              value={option.value}
            >
              <img
                width="40"
                height="40"
                src={`${ApiEndpoint}/${option.image}`}
                alt="Product"
              />
              <p>{option.label}</p>
            </StyledMenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}

export default ProductsList;
